import script from "./AboutPageList.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutPageList.vue?vue&type=script&setup=true&lang=js"

import "./AboutPageList.vue?vue&type=style&index=0&id=69da4f79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69da4f79"]])

export default __exports__